import React, { memo, ReactElement } from 'react'
import { Space } from 'antd'
import { ArrowRightOutlined } from '@ant-design/icons'
import cls from './note-default-template.module.css'
import Stage from '../../../activity-timeline-stage/stage/stage'

interface NoteChangeDataTemplateProps {
  className?: string
  children?: ReactElement
  oldData?: string
  newData?: string
}

const NoteChangeDataTemplate: React.FC<NoteChangeDataTemplateProps> = memo(
  (props: NoteChangeDataTemplateProps) => {
    const { className, children, oldData, newData } = props
    return (
      <>
        <Space className={className}>
          <Stage className={cls.stageColor}>{oldData}</Stage>
          <ArrowRightOutlined style={{ color: '#b1bac3' }} />
          <Stage className={cls.stageColor}>{newData}</Stage>
        </Space>
        {children}
      </>
    )
  },
)

NoteChangeDataTemplate.displayName = 'NoteChangeDataTemplate'
export default NoteChangeDataTemplate
